import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';

export default class FormErrorMessageComponent extends React.Component {
    static propTypes = {
        message: PropTypes.string,
        mode: PropTypes.string
    };
    static defaultProps = {
        mode: ''
    }

    render() {
        const { message, mode } = this.props;

        return typeof message === 'string' && message && (
            <p className={`component-form-error-message ${mode}`}>
                {message}
            </p>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/forms2/ErrorMessage/index.js